import { useState } from 'react';

/**
 * Hook for determing if a component is currently being hovered over
 */
const useHover = () => {
  const [isHovered, setHover] = useState(false);

  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  // bind to `onMouseEnter` and `onMouseLeave` listeners
  const bind = { onMouseEnter, onMouseLeave };

  return [ isHovered, bind ];
};

export default useHover;
